import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useCan } from '../../lib/authStore';
import { Icon } from '../../lib/icons';
import type { PermissionKey } from '@pcp/shared';

/**
 * Route/section gate: renders children when the user holds the permission
 * (array = ANY-OF), otherwise the house no-access empty state. Read access in
 * the app stays open — use this only for screens that are entirely actions
 * (e.g. Settings). Individual controls are hidden via useCan()/can() instead.
 */
export function RequirePermission({
  perm,
  children,
}: {
  perm: PermissionKey | PermissionKey[];
  children: ReactNode;
}) {
  const canDo = useCan();
  if (canDo(perm)) return <>{children}</>;

  return (
    <div className="page-container">
      <div className="glass-card-static">
        <div className="empty-state">
          <div className="empty-state-icon"><Icon name="lock" size={28} /></div>
          <div className="empty-state-title">No access</div>
          <div className="empty-state-description">
            You don&apos;t have permission to view this page. Ask an administrator to grant it.
          </div>
          <Link to="/" className="btn btn-secondary">
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
